import React, { useState, useEffect } from 'react';
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import DataTable from 'react-data-table-component';
import { doc, updateDoc} from 'firebase/firestore';
import { auth, db} from "../../firebase";
import {Utils} from '../utils/Utils'
import {Parser} from '../utils/Parser';
import { TeamsDB } from '../db/TeamsDB';

import "./Players.css";
import { CountriesDB } from '../db/CountriesDB';

const Players = () => {
  const [players, setPlayers] = useState([]);
  const [teams, setTeams] = useState([])
  const [countries, setCountries] = useState([])
  const [currentTeam, setCurrentTeam] = useState([])
  const [team, setTeam] = useState('')
  const [dorsal, setDorsal] = useState('')
  const [name, setName] = useState('')
  const [position, setPosition] = useState('')
  const [birthDate, setBirthDate] = useState('')
  const [height, setHeight] = useState('')
  const [nationality, setNationality] = useState('')
  const [nationality2, setNationality2] = useState('')
  const [licence, setLicence] = useState('')
  const [lastTeam, setLastTeam] = useState('')
  const [categoryLastTeam, setCategoryLastTeam] = useState('')
  const [countryLastTeam, setCountryLastTeam] = useState('')
  const [numMatches, setNumMatches] = useState('')
  const [minutes, setMinutes] = useState('')
  const [points, setPoints] = useState('')
  const [rebounds, setRebounds] = useState('')
  const [assists, setAssists] = useState('')
  const [steals, setSteals] = useState('')
  const [turnovers, setTurnovers] = useState('')
  const [blocks, setBlocks] = useState('')
  const [fg2m, setFg2m] = useState('')
  const [fg2a, setFg2a] = useState('')
  const [fg3m, setFg3m] = useState('')
  const [fg3a, setFg3a] = useState('')
  const [ftm, setFtm] = useState('')
  const [fta, setFta] = useState('')
  const [urlStats, setUrlStats] = useState('')
  const [urlPhoto, setUrlPhoto] = useState('')
  const [idPlayer, setIdPlayer] = useState('')

  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const keyCountries = "countries"

  const PAGE_SIZE = 10;

  useEffect(() => {
    if (!user) return navigate("/")

    TeamsDB.getFromPrimeraFEB(false).then((teamsData) => {
      if (teamsData) {
        setTeams(teamsData);
        setPlayers(teamsData.map(team => team.players).flat().filter(player => player !== undefined))
      } else {
        console.error('No se han encontrado equipos en la Primera FEB');
      }
    });
    CountriesDB.getAll().then(countriesData => {
      setCountries(countriesData)
    })
  }, [user,navigate]);

  const columns = [
    {
      name: 'Nombre',
      selector: row => row['name'],
      sortable: true,
    },
    {
      name: 'Posicion',
      selector: row => row['position'],
      sortable: true,
    },
    {
      name: 'Equipo',
      selector: row => getNameTeam(row['team']),
      sortable: true,
    },
    {
      cell:(row) => <svg onClick={(e) => handleEditar(e, row)} id={row.ID} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="iconAction"><path d="M1.172,19.119A4,4,0,0,0,0,21.947V24H2.053a4,4,0,0,0,2.828-1.172L18.224,9.485,14.515,5.776Z"/><path d="M23.145.855a2.622,2.622,0,0,0-3.71,0L15.929,4.362l3.709,3.709,3.507-3.506A2.622,2.622,0,0,0,23.145.855Z"/></svg>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      cell:(row) => <svg onClick={(e) => handleEliminar(e, row.id)} id={row.ID} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="iconAction"><path d="m17,4v-2c0-1.103-.897-2-2-2h-6c-1.103,0-2,.897-2,2v2H1v2h1.644l1.703,15.331c.169,1.521,1.451,2.669,2.982,2.669h9.304c1.531,0,2.813-1.147,2.981-2.669l1.703-15.331h1.682v-2h-6Zm-8-2h6v2h-6v-2Zm6.957,14.543l-1.414,1.414-2.543-2.543-2.543,2.543-1.414-1.414,2.543-2.543-2.543-2.543,1.414-1.414,2.543,2.543,2.543-2.543,1.414,1.414-2.543,2.543,2.543,2.543Z"/></svg>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  const handleGuardar = async () => {
    const nuevoJugador = {
      team: team,
      dorsal: dorsal,
      name: name,
      position: position,
      birthDate: birthDate,
      height: height * 1,
      nationality: nationality,
      nationality2: nationality2,
      licence: licence,
      lastTeam: lastTeam,
      categoryLastTeam: categoryLastTeam,
      countryLastTeam: countryLastTeam,
      numMatches: numMatches * 1,
      minutes: minutes,
      points: points * 1,
      rebounds: rebounds * 1,
      assists: assists * 1,
      steals: steals * 1,
      turnovers: turnovers * 1,
      blocks: blocks * 1,
      fg2m: fg2m * 1,
      fg2a: fg2a * 1,
      fg3m: fg3m * 1,
      fg3a: fg3a * 1,
      ftm: ftm * 1,
      fta: fta * 1,
      urlStats: urlStats,
      urlPhoto: urlPhoto
    };
    let teamRef
    let teamAfter = teams.filter(item => item.id === team)[0]
    try {
      teamRef = doc (db, 'teams', team)
    } catch (error) {
      console.error('Error al obtener el equipo: ', error)
    }
    if (idPlayer === '') {
      try {
        nuevoJugador.id = Utils.generateRandomId(20)
        if (teamAfter.players === undefined) {
          teamAfter.players = []
        }
        teamAfter.players.push(nuevoJugador)
        await updateDoc(teamRef, teamAfter)
        setPlayers([...players, nuevoJugador]);
        handleLimpiar()
      } catch (error) {
        console.error('Error al agregar el jugador:', error);
      }
    } else {
      nuevoJugador.id = idPlayer
      try {
        // Si cambia de equipo
        if (team !== currentTeam) {
          const teamRefPrevious =  doc (db, 'teams', currentTeam)
          let teamPrevious = teams.filter(item => item.id === currentTeam)[0]
          teamPrevious.players = teamPrevious.players.filter(player => player.id !== idPlayer)
          await updateDoc(teamRefPrevious, teamPrevious)
          teamAfter.players.push(nuevoJugador)
          await updateDoc(teamRef, teamAfter)
        // Si sigue en el mismo equipo
        } else {
          Utils.replaceItemInArray(teamAfter.players, nuevoJugador)
          await updateDoc(teamRef, teamAfter)
        }
        const nuevosJugadores = [...players];
        const index = nuevosJugadores.map(e => e.id).indexOf(idPlayer)
        
        nuevosJugadores[index] = nuevoJugador;
        setPlayers(nuevosJugadores);
        handleLimpiar()
      } catch (error) {
        console.error('Error al modificar el jugador:', error);
      }
    }
    
  };

  const handleEditar = (event, row) => {
    setCurrentTeam(row.team)
    setTeam(row.team)
    setDorsal(row.dorsal)
    setName(row.name)
    setPosition(row.position)
    setBirthDate(row.birthDate)
    setHeight(row.height * 1)
    setNationality(row.nationality)
    setNationality2(row.nationality2)
    setLicence(row.licence)
    setLastTeam(row.lastTeam)
    setCategoryLastTeam(row.categoryLastTeam)
    setCountryLastTeam(row.countryLastTeam)
    setNumMatches(row.numMatches)
    setMinutes(row.minutes)
    setPoints(row.points * 1)
    setRebounds(row.rebounds * 1)
    setAssists(row.assists * 1)
    setSteals(row.steals * 1)
    setTurnovers(row.turnovers * 1)
    setBlocks(row.blocks * 1)
    setFg2m(row.fg2m * 1)
    setFg2a(row.fg2a * 1)
    setFg3m(row.fg3m * 1)
    setFg3a(row.fg3a * 1)
    setFtm(row.ftm * 1)
    setFta(row.fta * 1)
    setUrlStats(row.urlStats)
    setUrlPhoto(row.urlPhoto)
    setIdPlayer(row.id)
  };

  const handleEliminar = async (event, id) => {
    if (window.confirm("Está seguro que desea eliminar el jugador?")) {
      let teamRef
      let teamAfter
      try {
        
        teamAfter = teams.filter(item => {
          if (item.players !== undefined) {
            const indexPlayer = item.players.findIndex(player => player.id === id)
            return (indexPlayer !== -1)
          } else {
            return false
          }       
        })[0]
        teamRef = doc (db, 'teams', teamAfter.id)
      } catch (error) {
        console.error('Error al obtener el equipo: ', error)
      }
      teamAfter.players = teamAfter.players.filter(player => player.id !== id)
      await updateDoc(teamRef, teamAfter)

      const nuevosJugadores = players.filter(jugador => jugador.id !== id)
      setPlayers(nuevosJugadores);
    }
  };

  const handleLimpiar = () => {
    setCurrentTeam('')
    setTeam('')
    setDorsal('')
    setName('')
    setPosition('')
    setBirthDate('')
    setHeight('')
    setNationality('')
    setNationality2('')
    setLicence('')
    setLastTeam('')
    setCategoryLastTeam('')
    setCountryLastTeam('')
    setNumMatches('')
    setMinutes('')
    setPoints('')
    setRebounds('')
    setAssists('')
    setSteals('')
    setTurnovers('')
    setBlocks('')
    setFg2m('')
    setFg2a('')
    setFg3m('')
    setFg3a('')
    setFtm('')
    setFta('')
    setUrlStats('')
    setUrlPhoto('')
    setIdPlayer('')
  }

  const handleLimpiarCachePaises = () => {
    localStorage.removeItem(keyCountries)
  }

  const getNameTeam = id => {
    const teamsFiltered = teams.filter(team => id === team.id)
    if (teamsFiltered.length === 1) {
      return teamsFiltered[0].name
    } 
    return ""
  }

  const showTeams = () => {
    return teams.map(team => <option value={team.id}>{team.name}</option>)
  }

  const showCountries = () => {
    return countries.map(country => <option value={country.name}>{country.name}</option>)
  }

  const fetchData = async () => {
    Parser.getDataByURL(urlStats).then( playerData => {
      if (playerData) {
        setUrlPhoto(playerData.urlPhoto || '');
        setCategoryLastTeam(playerData.categoryLastTeam || '');
        setCountryLastTeam(playerData.countryLastTeam || '');
        setPosition(playerData.position || '');
        setHeight(playerData.height || '');
        setBirthDate(playerData.birthDate || '');
        setNationality(playerData.nationality || '');
        setNumMatches(playerData.numMatches || '');
        setMinutes(playerData.minutes || '');
        setPoints(playerData.points || '');
        setRebounds(playerData.rebounds || '');
        setAssists(playerData.assists || '');
        setSteals(playerData.steals || '');
        setTurnovers(playerData.turnovers || '');
        setBlocks(playerData.blocks || '');
        setFg2m(playerData.fg2m || '');
        setFg2a(playerData.fg2a || '');
        setFg3m(playerData.fg3m || '');
        setFg3a(playerData.fg3a || '');
        setFtm(playerData.ftm || '');
        setFta(playerData.fta || '');
        setLastTeam(playerData.lastTeam || '');
        setName(playerData.name || '');
      }
    });
    
  }

  return (
    <div class="container-players">
      <h2>Jugadores</h2>
      
      <h3>Agregar Jugador</h3>
      <div id="data-player">
        <select 
        value={team}
        onChange={(e) => setTeam(e.target.value)}>
          <option value=""></option>
          {showTeams()}
        </select>
        <input
          type="number"
          placeholder="Dorsal"
          className="short"
          value={dorsal}
          onChange={(e) => setDorsal(e.target.value)}
        />
        <input
          type="text"
          placeholder="Nombre"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="number"
          placeholder="Pos."
          className="short"
          value={position}
          onChange={(e) => setPosition(e.target.value)}
        />
        <input
          type="text"
          placeholder="Fecha nacimiento"
          value={birthDate}
          onChange={(e) => setBirthDate(e.target.value)}
        />
        <input
          type="number"
          placeholder="Altura"
          className="short"
          value={height}
          onChange={(e) => setHeight(e.target.value)}
        />
        <label>Nacionalidades:</label>
        <select 
        value={nationality}
        onChange={(e) => setNationality(e.target.value)}>
          <option value=""></option>
          {showCountries()}
        </select>
        <select 
        value={nationality2}
        onChange={(e) => setNationality2(e.target.value)}>
          <option value=""></option>
          {showCountries()}
        </select>
        <input
          type="text"
          placeholder="Licencia"
          className="short"
          value={licence}
          onChange={(e) => setLicence(e.target.value)}
        />
        <input
        type="text"
        placeholder="URL Foto"
        value={urlPhoto}
        onChange={(e) => setUrlPhoto(e.target.value)}
      />
      </div>
      <div id="data-last-season">
        <label>Temporada 25/26</label>
        <input
          type="text"
          placeholder="Equipo"
          value={lastTeam}
          onChange={(e) => setLastTeam(e.target.value)}
        />
        <input
          type="text"
          placeholder="Categoría"
          value={categoryLastTeam}
          onChange={(e) => setCategoryLastTeam(e.target.value)}
        />
        <select 
        value={countryLastTeam}
        onChange={(e) => setCountryLastTeam(e.target.value)}>
          <option value=""></option>
          {showCountries()}
        </select>
      </div>
      <div id="stats-last-season">
        <input
          type="number"
          placeholder="Part."
          className="short"
          value={numMatches}
          onChange={(e) => setNumMatches(e.target.value)}
        />
        <input
          type="text"
          placeholder="Mins"
          className="short"
          value={minutes}
          onChange={(e) => setMinutes(e.target.value)}
        />
        <input
          type="number"
          placeholder="Pts"
          className="short"
          value={points}
          onChange={(e) => setPoints(e.target.value)}
        />
        <input
          type="number"
          placeholder="Rebs"
          className="short"
          value={rebounds}
          onChange={(e) => setRebounds(e.target.value)}
        />
        <input
          type="number"
          placeholder="Asis"
          className="short"
          value={assists}
          onChange={(e) => setAssists(e.target.value)}
        />
        <input
          type="number"
          placeholder="Robos"
          className="short"
          value={steals}
          onChange={(e) => setSteals(e.target.value)}
        />
        <input
          type="number"
          placeholder="Perd."
          className="short"
          value={turnovers}
          onChange={(e) => setTurnovers(e.target.value)}
        />
        <input
          type="number"
          placeholder="Taps"
          className="short"
          value={blocks}
          onChange={(e) => setBlocks(e.target.value)}
        />
        <input
          type="number"
          placeholder="T2A"
          className="short"
          value={fg2m}
          onChange={(e) => setFg2m(e.target.value)}
        />
        <input
          type="number"
          placeholder="T2I"
          className="short"
          value={fg2a}
          onChange={(e) => setFg2a(e.target.value)}
        />
        <input
          type="number"
          placeholder="T3A"
          className="short"
          value={fg3m}
          onChange={(e) => setFg3m(e.target.value)}
        />
        <input
          type="number"
          placeholder="T3I"
          className="short"
          value={fg3a}
          onChange={(e) => setFg3a(e.target.value)}
        />
        <input
          type="number"
          placeholder="TLA"
          className="short"
          value={ftm}
          onChange={(e) => setFtm(e.target.value)}
        />
        <input
          type="number"
          placeholder="TLI"
          className="short"
          value={fta}
          onChange={(e) => setFta(e.target.value)}
        />
        <input
          type="text"
          placeholder="URL Stats"
          value={urlStats}
          onChange={(e) => setUrlStats(e.target.value)}
        />
      </div>
      <button onClick={fetchData}>Obtener datos</button>
      
      <button onClick={handleGuardar}>Guardar</button>
      <button onClick={handleLimpiar}>Limpiar</button>
      <button onClick={handleLimpiarCachePaises}>Limpiar cache paises</button>
      <div className="table">
        <DataTable
          columns={columns}
          data={players}
          pagination
          paginationTotalRows={players.length}
          paginationPerPage={PAGE_SIZE}
          paginationRowsPerPageOptions={[PAGE_SIZE]}
      />
      </div>
    </div>
  );
};

export default Players;